import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const i = e(
  (r, s) => /* @__PURE__ */ o.jsx(
    t,
    {
      ref: s,
      ...r,
      image: (a) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...a,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M8 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8M1 14v-1a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1"
            }
          )
        }
      )
    }
  )
);
i.displayName = "UserIcon";
export {
  i as UserIcon,
  i as default
};
//# sourceMappingURL=index.js.map
